import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import axios from 'axios'

import GMSGeometry from '../Helpers/GMSGeometry';
import firebase from '../Configs/firebase'
import Config from '../Configs/staticConfig'
class MapsPlanDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isSmallExpanded: false,
            isSaved: false,
        };
        this.activateSmallExpanded = this.activateSmallExpanded.bind(this);
        this.deactivateSmallExpanded = this.deactivateSmallExpanded.bind(this);
        this.handleClose = this.handleClose.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.handleEdit = this.handleEdit.bind(this)
        this.handleShare = this.handleShare.bind(this)
        this.handleExportCSV = this.handleExportCSV.bind(this)
    }

    activateSmallExpanded() {
        this.setState({
            isSmallExpanded: true
        });
    }

    deactivateSmallExpanded() {
        this.setState({
            isSmallExpanded: false
        });
    }

    handleClose(){
        const {setCurrentPlan,setCurrentDroneLayer} = this.props
        setCurrentPlan(null)
        setCurrentDroneLayer(null)
    }

    handleEdit(){
        const { setEdited } = this.props
        setEdited(true)
    }

    handleSave(e){
        e.preventDefault()
        const { plan } = this.props
        firebase.firestore().collection('plans').doc(plan.uid).update({
            ['saved_uid.'+[firebase.auth().currentUser.uid]]:new Date()
        })
        .then(()=>{
            this.setState({
                isSaved:true
            })
        })
        .catch(err=>{
            console.log(err)
        })
    }

    handleShare(){
        this.props.setIsOpenShareDialog(true)
    }

    handleExportCSV(){
        const { plan } = this.props
        var body = { id:plan.uid }
        axios.post(Config.getGenerateCSVRequestUrl(),body)
        .then(res=>{
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', plan.name+'.csv');
            document.body.appendChild(link);
            link.click();
            link.remove();
        })
    }

    render() {
        const { isSmallExpanded, isSaved } = this.state;
        const { plan, isLoaded, user } = this.props;
        var planGeneralDetails = null
        var planGeoDetails = null
        var mapsDetailsClasses = 'MapsDetails box';

        var leftButton = null
        var closeButton =   <div className="ListHeader">
                                <Link to={'/mymap'} replace>
                                    <div onClick={this.handleClose}> 
                                        <span className="CloseMenu"><i className="fas fa-times"></i></span>    
                                    </div>
                                </Link>
                            </div>

        if ( isSmallExpanded === true ) {
            mapsDetailsClasses += ' is-small-expanded'
            closeButton = null
        }

        if ( !isLoaded ) {
            return (
                <div className={mapsDetailsClasses}>
                    <span className="MapsDetailsLoadingIcon icon is-medium">
                        <i className="fas fa-spinner fa-pulse fa-2x"></i>
                    </span>
                </div>
            );
        }
        else if ( plan === undefined || plan === null || plan === false ) {
            return (
                <div className={mapsDetailsClasses}>
                    <div className="content">
                        <div className="MapsPlanHeader">
                            <h5 className="MapsPlanName title has-text-white is-size-5">ไม่พบข้อมูล</h5>
                            <p className="MapsPlanErrorDescription has-text-grey-light">The link you followed may be broken, or the page may have been removed.</p>
                        </div>
                    </div>
                </div>
            )
        }
        
        const planUtmString = GMSGeometry.latLngToUtmString(plan.planLatLng());

        if ( planUtmString !== null ) {
            planGeoDetails =    <div>
                                    <hr />
                                    <h6 className="title is-size-6">ข้อมูลทางภูมิศาสตร์</h6>
                                    <div className="MapsPlanFieldValue">
                                        <p className="MapsPlanField has-text-grey-light has-text-weight-bold">ตำแหน่ง X, Y</p>
                                        <p className="MapsPlanValue">{planUtmString}</p>
                                    </div>
                                </div> 
        }
        
        if ( plan.hasAnyGeneralDetails() === true ) {
            planGeneralDetails = (
                <React.Fragment>
                    <hr />
                    <h6 className="title is-size-6">ข้อมูลทั่วไป</h6>
                    {
                        ( plan.address !== '' ) ? (
                            <div className="MapsPlanFieldValue">
                                <p className="MapsPlanField has-text-grey-light has-text-weight-bold">ที่อยู่</p>
                                <p>{plan.address}</p>
                            </div>
                        ) : null
                    }
                    {
                        ( plan.deed !== '' ) ? (
                            <div className="MapsPlanFieldValue">
                                <p className="MapsPlanField has-text-grey-light has-text-weight-bold">โฉนดที่ดิน</p>
                                <p>{plan.deed}</p>
                            </div>
                        ) : null
                    }
                    {
                        ( plan._description !== '' ) ? (
                            <div className="MapsPlanFieldValue">
                                <p className="MapsPlanField has-text-grey-light has-text-weight-bold">รายละเอียดเพิ่มเติม</p>
                                <p>{plan._description}</p>
                            </div>
                        ) : null
                    }
                </React.Fragment>
            );
        }

        if ( user !== null &&  user !== undefined && plan.userUid === user.uid){
            leftButton = <button className="button is-primary is-rounded is-outlined share-and-save" onClick={this.handleEdit}>Edit</button>
        }
        else if ( user !== null && user !== undefined && plan.userUid !== user.uid && plan.uid !== ""){
            if( plan.savedUid !== null && ((plan.savedUid[user.uid] !== undefined && plan.savedUid[user.uid].toDate() <= new Date()) || isSaved === true )){
                leftButton = null
            }
            else{
                leftButton = <button onClick={this.handleSave} className="button is-primary is-rounded is-outlined share-and-save">Save</button>
            }
        }
        return (
            <div className={mapsDetailsClasses}>
                {closeButton}
                <div className="MapsDetailsExpander has-text-grey-lighter has-text-centered" onClick={this.activateSmallExpanded}>
                    <span className="icon"><i className="fas fa-chevron-up fa-lg"></i></span>
                </div>
                <div className="MapsDetailsCollapser has-text-grey-lighter" onClick={this.deactivateSmallExpanded}>
                    <span className="icon"><i className="fas fa-times fa-lg"></i></span>
                </div>
                <div className="content">
                    <div className="MapsPlanHeader">
                        <h5 className="MapsPlanName title has-text-white is-size-5">{plan.name}</h5>
                        <p className="MapsPlanCreatedAt has-text-grey-light is-size-7">แก้ไขล่าสุดเมื่อ {plan.updatedAtString()}</p>
                        <p className="MapsPlanCreatedAt has-text-grey-light is-size-7">โดย {plan.userName}</p>
                        <p className="MapsPlanXY has-text-grey-light">{planUtmString}</p>
                        <p className="MapsPlanArea has-text-grey-light">{plan.planAreaString()}</p>
                        <div className="is-max-width">
                            {leftButton}
                            <button className="button is-primary is-rounded share-and-save" onClick={this.handleShare}>Share</button>
                        </div>
                        <div className="line-it-button" style={{display:"block"}} data-lang="en" data-type="share-a" data-ver="2" data-url="https://www.google.com"></div>

                    </div>
                    <div className="MapsPlanMoreDetails">
                        { planGeoDetails }
                        { planGeneralDetails }
                        <br/>
                        <div className="is-max-width">
                            <button className="button is-primary is-outlined is-rounded share-and-save" onClick={this.handleExportCSV}>Export to csv</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default MapsPlanDetails;


// WEBPACK FOOTER //
// ./src/PageMaps/_MapsPlanDetails.js